import type { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'

import type { BlogTag } from '@/types/blog'

type Props = {
  tag: Pick<BlogTag, 'name' | 'tagColor'>
  isActive: boolean
} & ComponentPropsWithoutRef<'button'>

export const BlogTagButton = ({ tag, isActive, ...props }: Props) => {
  return (
    <TagButton
      type="button"
      aria-pressed={isActive}
      color={tag.tagColor}
      {...props}
    >
      {tag.name}
    </TagButton>
  )
}

const TagButton = styled.button<{ color: string }>`
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0;
  background-color: #ffffff;
  color: ${({ color }) => color};
  padding: 0 18px 0 16px;
  border: 1px solid ${({ color }) => color};
  border-radius: 14px;
  cursor: pointer;
  transition: 0.3s;

  &[disabled] {
    cursor: default;
  }

  @media (hover: hover) {
    &:hover {
      opacity: 0.6;
    }
  }

  &[aria-pressed='true'] {
    color: #ffffff;
    background-color: ${({ color }) => color};
  }
`
